"use strict";
/* globals module */
/**
 * @module filesRoute
 * @description Baasic Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var _1 = require("./");
var contracts_1 = require("../../core/contracts");
var FilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(FilesRoute, _super);
    function FilesRoute(appOptions, filesStreamsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.filesStreamsRoute = filesStreamsRoute;
        _this.findRoute = 'files/{?searchQuery,page,rpp,sort,embed,fields,fileName,from,to,ids,minFileSize,maxFileSize}';
        _this.getRoute = 'files/{id}/{?embed,fields}';
        _this.updateRoute = 'files/{id}';
        _this.unlinkRoute = 'files/unlink/{id}/{?height,width}';
        _this.linkRoute = 'files/link';
        return _this;
    }
    Object.defineProperty(FilesRoute.prototype, "streams", {
        get: function () {
            return this.filesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example filesRoute.find({searchQuery: '<search-phrase>'});
     **/
    FilesRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param id File id which uniquely identifies file resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example filesRoute.get({id: '<file-id>'});
     **/
    FilesRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of the file resource.
     * @method
     * @param data A file entry object used to update specific file entry resource in the system.
     * @example filesRoute.get({id: '<file-id>'});
     **/
    FilesRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses unlink route; this route should be expanded with the Id of the file resource.
     * @method
     * @param data A file entry object used to update specific file entry resource in the system.
     * @example filesRoute.unlink({id: '<file-id>'});
     **/
    FilesRoute.prototype.unlink = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options, 'unlink');
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @example filesRoute.link();
     **/
    FilesRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    var _a, _b;
    FilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.FilesStreamsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.FilesStreamsRoute !== "undefined" && _1.FilesStreamsRoute) === "function" ? _b : Object])
    ], FilesRoute);
    return FilesRoute;
}(common_1.BaseRoute));
exports.FilesRoute = FilesRoute;
/**
 * @overview
***Notes:**
- Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
- [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 
